import { useEffect, useState } from "react";
import { LockOutlined, UnlockOutlined } from "@ant-design/icons";
import TextInput from "src/Components/TextInput";
import { ParameterValue } from "src/Interfaces/systemParameters";

export default function ParameterField({label,value,onChange,disabled=false,withSourceToggle=true}: {
  label:string; value:ParameterValue; onChange:(value:ParameterValue)=>void; disabled?:boolean; withSourceToggle?:boolean;
}) {
  const [draft,setDraft]=useState(value.manualPercent?.toString() ?? "");
  useEffect(() => setDraft(value.manualPercent?.toString() ?? ""),[value.manualPercent,value.useCentral]);
  const toggle=() => onChange(value.useCentral
    ? {...value,useCentral:false,effectivePercent:value.manualPercent}
    : {...value,useCentral:true,effectivePercent:value.centralPercent});
  return <div className="flex flex-col gap-1.5">
    <div className="flex items-center justify-between gap-2">
      <span className="text-xs text-slate-700">{label} (%)</span>
      <span className={`text-[10px] ${value.useCentral?"text-sky-600":"text-slate-400"}`}>{value.useCentral?"مرکزی":"دستی"}</span>
    </div>
    <div className="flex items-stretch gap-1">
      <label className={`min-w-0 flex-1 ${value.useCentral?"opacity-50":""}`}>
        <span className="sr-only">{label} (%)</span>
        <TextInput name={label} label="—" autoComplete={false} direction="ltr" value={draft}
          kind="percent" allowPercentAbove100 disabled={disabled || value.useCentral}
          onChange={(_,v) => {
          const text=v ?? "";
          if(!/^\d*\.?\d{0,8}$/.test(text))return;
          setDraft(text); const next=text==="" || text==="." ? null : Number(text);
          onChange({...value,manualPercent:next,effectivePercent:next});
        }} />
      </label>
      {withSourceToggle ? <button type="button" onClick={toggle} disabled={disabled} aria-pressed={value.useCentral}
        aria-label={value.useCentral?`ورود دستی ${label}`:`اتصال ${label} به مرکز`}
        title={value.useCentral?"متصل به مرکز؛ برای ورود دستی باز کنید":"دستی؛ برای اتصال به مرکز قفل کنید"}
        className={`flex w-8 shrink-0 items-center justify-center rounded border outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-sky-500 disabled:opacity-50 ${value.useCentral?"border-sky-200 text-sky-600 hover:bg-sky-100":"border-slate-200 text-slate-500 hover:bg-slate-50"}`}>
        {value.useCentral?<LockOutlined />:<UnlockOutlined />}
      </button> : null}
    </div>
  </div>;
}
